import { makeAutoObservable, runInAction } from 'mobx';
import { TechSupportApi, RedisConfigItemDTO, SmsCodeStatusDTO } from '../../apis/TechSupport';

export class TechnicalSupportManagementPageModel {
  activeTab = 'redis';
  loading = false;
  redisConfigs: RedisConfigItemDTO[] = [];
  editingConfig: RedisConfigItemDTO | null = null;
  isEditModalVisible = false;

  smsQueryPhone = '';
  smsSendPhone = '';
  smsCodeLoading = false;
  smsSendLoading = false;
  smsCodeStatus: SmsCodeStatusDTO | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setActiveTab(tab: string) {
    this.activeTab = tab;
  }

  setSmsQueryPhone(phone: string) {
    this.smsQueryPhone = phone;
  }

  setSmsSendPhone(phone: string) {
    this.smsSendPhone = phone;
  }

  async loadRedisConfigs() {
    this.loading = true;
    try {
      const configs = await TechSupportApi.getRedisConfigs();
      runInAction(() => {
        this.redisConfigs = configs;
        this.loading = false;
      });
    } catch (error) {
      runInAction(() => {
        this.loading = false;
      });
      throw error;
    }
  }

  showEditModal(config: RedisConfigItemDTO) {
    this.editingConfig = { ...config };
    this.isEditModalVisible = true;
  }

  hideEditModal() {
    this.isEditModalVisible = false;
    this.editingConfig = null;
  }

  updateEditingValue(value: string) {
    if (this.editingConfig) {
      this.editingConfig.value = value;
    }
  }

  async savePraiseWallMinPrice(value: number) {
    const success = await TechSupportApi.setPraiseWallMinPrice(value);
    if (!success) {
      throw new Error('保存失败');
    }
    await this.loadRedisConfigs();
    this.hideEditModal();
  }

  async querySmsCodeStatus() {
    const phone = this.smsQueryPhone.trim();
    if (!phone) {
      throw new Error('请输入手机号');
    }
    this.smsCodeLoading = true;
    try {
      const status = await TechSupportApi.getSmsCodeStatus(phone);
      runInAction(() => {
        this.smsCodeStatus = status;
        this.smsCodeLoading = false;
      });
    } catch (error) {
      runInAction(() => {
        this.smsCodeLoading = false;
      });
      throw error;
    }
  }

  async sendSmsCode() {
    const phone = this.smsSendPhone.trim();
    if (!phone) {
      throw new Error('请输入手机号');
    }
    this.smsSendLoading = true;
    try {
      const success = await TechSupportApi.sendSmsCode(phone);
      if (!success) {
        throw new Error('发放失败');
      }
      runInAction(() => {
        this.smsSendLoading = false;
      });
    } catch (error) {
      runInAction(() => {
        this.smsSendLoading = false;
      });
      throw error;
    }
  }
}
